export const MACRO_NAME = 'macro';
// 자주쓰는문구(매크로) 서버 백업 완료 여부. 브라우저 전역 단일 flag.
export const MACRO_BACKUP_FLAG_NAME = 'macro_backup_done';
export const ACCESS_TOKEN_NAME = 'access';
export const REFRESH_TOKEN_NAME = 'refresh';
export const LAST_ACTION = 'lastAction';
export const LAST_SOUND = 'lastSound';
const FIRST_DEPTH_NOTIFICATION = 'firstDepthNotification';
export const NORMAL_MESSAGE_NOTIFICATION = 'normalMessageNotification';
export const BIZ_PROFILE_MESSAGE_NOTIFICATION = 'bizMessageNotification';
export const CHANNEL_MUTE_LIST = 'channelMuteList';
export const NOTIFICATION_BANNER = 'notificationBanner';
export const AUTO_REPLY_INTRO = 'autoReplyIntro';
export const BA_ID = 'baId';

if (getLocalStorage(FIRST_DEPTH_NOTIFICATION) === true || getLocalStorage(NORMAL_MESSAGE_NOTIFICATION) === undefined) {
  setLocalStorage({ key: NORMAL_MESSAGE_NOTIFICATION, value: true });
  setLocalStorage({ key: BIZ_PROFILE_MESSAGE_NOTIFICATION, value: true });
  removeLocalStorage(FIRST_DEPTH_NOTIFICATION);
} else if (getLocalStorage(FIRST_DEPTH_NOTIFICATION) === false) {
  setLocalStorage({ key: NORMAL_MESSAGE_NOTIFICATION, value: false });
  setLocalStorage({ key: BIZ_PROFILE_MESSAGE_NOTIFICATION, value: false });
  removeLocalStorage(FIRST_DEPTH_NOTIFICATION);
}

interface localStorageTypes {
  key: string
  value: unknown
}
export function setLocalStorage({ key, value }: localStorageTypes) {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {}
}
export function getLocalStorage(key: string) {
  try {
    const value = localStorage.getItem(key);
    return value ? JSON.parse(value) : undefined;
  } catch {}
}
export function removeLocalStorage(key: string) {
  try {
    localStorage.removeItem(key);
  } catch {}
}



export function setBaId(baId: string | number) {
  setLocalStorage({ key: BA_ID, value: String(baId) });
}

export function getBaId(): string | undefined {
  return getLocalStorage(BA_ID);
}

export function removeBaId() {
  removeLocalStorage(BA_ID);
}
